module.exports = __webpack_public_path__ + "static/media/experience-preview.1100371d.png";